import {
  DEPARTMENT_FETCH_REQUEST,
  DEPARTMENT_FETCH_REQUEST_SUCCESS,
  DEPARTMENT_FETCH_REQUEST_FAILURE,
  DEPARTMENT_ADD_REQUEST,
  DEPARTMENT_ADD_REQUEST_SUCCESS,
  DEPARTMENT_ADD_REQUEST_FAILURE,
  DEPARTMENT_UPDATE_REQUEST,
  DEPARTMENT_UPDATE_REQUEST_SUCCESS,
  DEPARTMENT_UPDATE_REQUEST_FAILURE,
  DEPARTMENT_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const departmentsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DEPARTMENT_FETCH_REQUEST:
    case DEPARTMENT_ADD_REQUEST:
    case DEPARTMENT_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case DEPARTMENT_FETCH_REQUEST_SUCCESS:
    case DEPARTMENT_ADD_REQUEST_SUCCESS:
    case DEPARTMENT_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case DEPARTMENT_FETCH_REQUEST_FAILURE:
    case DEPARTMENT_ADD_REQUEST_FAILURE:
    case DEPARTMENT_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case DEPARTMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default departmentsReducer;
